import { LSWH_SYSTEM_PROMPT } from "./aiPrompts";

export const LSWH_CONFIG = {
  systemPrompt: LSWH_SYSTEM_PROMPT,
  getStudentReportInfo: (v) => ({
    grade: v.grade,
    daysAbsent: v.daysAbsent,
    timesLate: v.timesLate,
    // Term 1
    responsibility1: v.responsibility1,
    organization1: v.organization1,
    independentWork1: v.independentWork1,
    collaboration1: v.collaboration1,
    initiative1: v.initiative1,
    selfRegulation1: v.selfRegulation1,
    // Term 2
    responsibility2: v.responsibility2,
    organization2: v.organization2,
    independentWork2: v.independentWork2,
    collaboration2: v.collaboration2,
    initiative2: v.initiative2,
    selfRegulation2: v.selfRegulation2,
  }),
};
